module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"indoor":"Binnen","outdoor":"Buiten","both":"Beide"}}')
  delete Component.options._Ctor
}
